import { render } from "./batchGiveModel.vue?vue&type=template&id=42457cc3"
import script from "./batchGiveModel.vue?vue&type=script&lang=js"
export * from "./batchGiveModel.vue?vue&type=script&lang=js"

import "./batchGiveModel.vue?vue&type=style&index=0&id=42457cc3&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__